import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Route, Routes, useLocation } from "react-router-dom";

import LanguageSelector from "./components/Menu/LanguageSelector";
import { ConversationProvider } from "./contexts/conversationContext";
import Chat from "./pages/chat/Chat";
import NoPage from "./pages/NoPage";


export default function App() {
    const theme = useTheme();
    const { t } = useTranslation("translation", { keyPrefix: "common" });
    const location = useLocation();

    return (
            <Box
                sx={{
                    height: "100dvh",
                    maxHeight: "100dvh",
                    maxWidth: "100vw",
                    display: "flex",
                    flexDirection: "column",
                    background: theme.palette.containerBG,
                    position: "relative"
                }}
            >
                <LanguageSelector />
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        overflow: "auto"
                    }}
                >
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <ConversationProvider>
                                    <Chat />
                                </ConversationProvider>
                            }
                        />
                        <Route path="*" element={<NoPage />} />
                    </Routes>

                    {location.pathname !== "/" && (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: "auto",
                                marginBottom: "8px",
                                gap: 0.5
                            }}
                        >

                            <Typography
                                sx={{
                                    color: theme.palette.disclaimerText,
                                    fontSize: "0.875rem",
                                    lineHeight: "1"
                                }}
                            >
                                {t("copyright")}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
    );
}
